import type { Channel, Outcome } from '../types/portal'

export interface ActivityEntry {
  id: string
  channel: Channel
  outcome: Outcome
  timestamp: string
  note: string
  author: string
}

/** Manually logged communication, keyed by lead / partner record id. */
export const activityLog: Record<string, ActivityEntry[]> = {
  'L-40208': [
    {
      id: 'ACT-7712',
      channel: 'call',
      outcome: 'left-voicemail',
      timestamp: 'Today, 6:05 AM',
      note: 'Left a voicemail introducing myself and the streamline option. Will try again mid-morning.',
      author: 'Jordan Reyes',
    },
    {
      id: 'ACT-7705',
      channel: 'email',
      outcome: 'connected',
      timestamp: 'Yesterday, 9:12 PM',
      note: 'Sent rate quote confirmation and the document checklist.',
      author: 'Jordan Reyes',
    },
  ],
  'L-40201': [
    {
      id: 'ACT-7698',
      channel: 'email',
      outcome: 'connected',
      timestamp: 'Yesterday, 7:50 PM',
      note: 'Thanked them for stopping by the open house and outlined VA benefits.',
      author: 'Jordan Reyes',
    },
  ],
  'L-40188': [
    {
      id: 'ACT-7726',
      channel: 'call',
      outcome: 'connected',
      timestamp: 'Today, 8:14 AM',
      note: 'Discussed a 2-1 buydown on the $402,000 target. Sending two payment scenarios today.',
      author: 'Jordan Reyes',
    },
    {
      id: 'ACT-7690',
      channel: 'text',
      outcome: 'connected',
      timestamp: 'Aug 07, 4:20 PM',
      note: 'Confirmed they are touring homes this weekend with Jamal Whitcomb.',
      author: 'Jordan Reyes',
    },
  ],
  'L-40176': [
    {
      id: 'ACT-7728',
      channel: 'call',
      outcome: 'connected',
      timestamp: 'Today, 8:41 AM',
      note: 'Rate lock question. Explained the 45-day lock and float-down policy.',
      author: 'Jordan Reyes',
    },
  ],
  'L-40154': [
    {
      id: 'ACT-7731',
      channel: 'video',
      outcome: 'application-started',
      timestamp: 'Today, 9:30 AM',
      note: 'Walked through the full application. Borrower will upload pay stubs tonight.',
      author: 'Jordan Reyes',
    },
    {
      id: 'ACT-7671',
      channel: 'in-person',
      outcome: 'meeting-set',
      timestamp: 'Aug 03, 1:00 PM',
      note: 'Met at the Golden open house. Scheduled the application walkthrough.',
      author: 'Jordan Reyes',
    },
  ],
  'L-40131': [
    {
      id: 'ACT-7602',
      channel: 'text',
      outcome: 'no-answer',
      timestamp: 'Aug 02, 11:15 AM',
      note: 'Checked in on refinance timing. No response yet — moved to nurture.',
      author: 'Jordan Reyes',
    },
  ],
  'L-40117': [
    {
      id: 'ACT-7488',
      channel: 'call',
      outcome: 'not-interested',
      timestamp: 'Jul 26, 3:40 PM',
      note: 'Paused the search until spring. Re-engage in 60 days.',
      author: 'Jordan Reyes',
    },
  ],
  'A-2201': [
    {
      id: 'ACT-7654',
      channel: 'email',
      outcome: 'connected',
      timestamp: 'Aug 02, 10:05 AM',
      note: 'Sent the co-marketing flyer draft for the fall listing push.',
      author: 'Jordan Reyes',
    },
    {
      id: 'ACT-7611',
      channel: 'in-person',
      outcome: 'meeting-set',
      timestamp: 'Jul 28, 8:00 AM',
      note: 'Coffee meeting — agreed to co-host an open house every other weekend.',
      author: 'Jordan Reyes',
    },
  ],
  'A-2188': [
    {
      id: 'ACT-7580',
      channel: 'call',
      outcome: 'connected',
      timestamp: 'Jul 30, 2:15 PM',
      note: 'Reviewed Beatrice Lund pre-approval. Promised an updated rate scenario — still outstanding.',
      author: 'Jordan Reyes',
    },
  ],
  'A-2176': [
    {
      id: 'ACT-7725',
      channel: 'call',
      outcome: 'connected',
      timestamp: 'Today, 8:20 AM',
      note: 'Reviewed the August buyer pipeline. Two buyers need pre-approval refreshes.',
      author: 'Jordan Reyes',
    },
    {
      id: 'ACT-7663',
      channel: 'in-person',
      outcome: 'connected',
      timestamp: 'Aug 04, 10:00 AM',
      note: 'Office visit at RE/MAX Lakewood. Presented buydown scenarios to eight agents.',
      author: 'Jordan Reyes',
    },
  ],
  'A-2165': [
    {
      id: 'ACT-7640',
      channel: 'call',
      outcome: 'connected',
      timestamp: 'Aug 03, 4:45 PM',
      note: 'Asked for a 2-1 buydown comparison for two active buyers.',
      author: 'Jordan Reyes',
    },
  ],
  'A-2151': [
    {
      id: 'ACT-7702',
      channel: 'text',
      outcome: 'connected',
      timestamp: 'Aug 08, 8:35 AM',
      note: 'Sent the underwriting status update for the shared buyer.',
      author: 'Jordan Reyes',
    },
  ],
  'A-2170': [
    {
      id: 'ACT-7708',
      channel: 'email',
      outcome: 'connected',
      timestamp: 'Aug 07, 9:05 AM',
      note: 'Sent the construction loan one-pager. New partner — day 34 of 90.',
      author: 'Jordan Reyes',
    },
  ],
  'A-2140': [
    {
      id: 'ACT-7521',
      channel: 'in-person',
      outcome: 'connected',
      timestamp: 'Jul 27, 11:30 AM',
      note: 'Quarterly business review kickoff. Follow-up deck still owed — now overdue.',
      author: 'Jordan Reyes',
    },
  ],
  'P-3310': [
    {
      id: 'ACT-7684',
      channel: 'in-person',
      outcome: 'meeting-set',
      timestamp: 'Aug 05, 7:30 AM',
      note: 'Coffee — agreed to trade two referrals per month starting in September.',
      author: 'Jordan Reyes',
    },
  ],
  'P-3325': [
    {
      id: 'ACT-7455',
      channel: 'call',
      outcome: 'connected',
      timestamp: 'Jul 20, 1:10 PM',
      note: 'Introduced the referral exchange. No activity since — needs re-engagement.',
      author: 'Jordan Reyes',
    },
  ],
}
